import { ParticipantTypeEnum } from "@/enums/RecapEnums";
import { RecapAttendanceTags } from "@/interfaces/IRecap";
import { Tag } from "antd";

const AttendanceTag = ({ value }: { value: ParticipantTypeEnum }) => {
  const status = RecapAttendanceTags().find((item) => item?.value === value);

  if (!status) return null;

  return (
    <Tag
      className="mx-1"
      style={{
        color: status.color,
        borderColor: status.color,
        backgroundColor: status.backgroundColor,
      }}
    >
      {status.label}
    </Tag>
  );
};

export default AttendanceTag;
